<template>
  <div class="xin-list">
    <div class="input">
      <div class="list">
        <div class="one">
          <input
            type="text"
            readonly
            v-model="searchText"
            class="inp"
            @click="show = true"
          />
          <van-action-sheet
            v-model="show"
            :actions="option1"
            @select="onSelect"
          />
        </div>
        <div class="two">
          <van-search
            @search="getSearch"
            v-model="title"
            placeholder="请输入搜索关键词"
          />
        </div>
        <p @click="qx" v-if="isshow">取消</p>
        <p v-else @click="qx">清空</p>
      </div>
    </div>

    <div class="box" v-if="(a = true)">
      <div class="tap">
        <p
          @click="pp(index, item.value)"
          :class="[{ acp: shos == index }]"
          v-for="(item, index) in list"
          :key="index"
        >
          {{ item.text }}
        </p>
      </div>
      <!-- <div class="banner">
        <p >关键字搜索</p>
      </div> -->
    </div>
    <div class="item_list" v-if="listall.length">
      <div class="list">查到{{ listall.length }}个结果</div>
      <div class="fangda">
        <div class="fang" v-for="item in listall" :key="item.id">
          <div class="fang_img">
            <div class="img-item">
              <img :src="item.titleUrl" alt="" />
            </div>
          </div>
          <div class="zi_list">
            <p>{{ item.title }}</p>
            <div class="right-botttom vottom">
              <div style="display: flex; align-items: center">
                <img src="../../assets/yan.png" alt="" />
                <p>{{ item.pageview }}人观看</p>
              </div>

              <div class="button" @click="goHorizons(item.id)">去学习</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-empty v-else image="error" description="暂无数据" />
  </div>
</template>

<script>
import axios from "axios";
import { Toast } from "vant";

export default {
  data() {
    return {
      shos: 0,
      isshow: true,
      name: "",
      value1: 4,
      title: "", //名称
      type: "", // 类型
      day: "", // 时间
      listall: [], //搜索数据
      list: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "近1个月",
          value: 30,
        },
        {
          text: "近3个月",
          value: 90,
        },
        {
          text: "近6个月",
          value: 180,
        },
      ],
      option1: [
        { name: "心灵之窗", value: 0 },
        { name: "心灵美文", value: 1 },
        { name: "心灵知识", value: 2 },
        { name: "心灵视界", value: 3 },
      ],
      searchText: "请选择",
      show: false,
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      this.searchText = item.name;
      this.type = item.value;
      this.getSearch();
    },
    Fnchange(value) {
      this.type = value;
    },
    //
    getdata() {},
    //搜索
    async getSearch() {
      if (this.type === "") {
        Toast.fail("请选择你的选项");
        return;
      }
      const toast = Toast.loading({
        message: "加载中...", //加载的时候显示的文字
        duration: 0, //展示时长(ms)，值为 0 时，toast 不会消失
        overlay: false, //是否显示遮罩层
        forbidClick: true, //是否禁止背景点击
      });
      axios({
        url: "/api/system/articles/searchArticlesByTitle",
        method: "get",
        params: {
          title: this.title,
          day: this.day,
          type: this.type,
        },
      }).then((res) => {
        toast.clear();
        this.listall = res.data.rows;
      });
    },
    pp(index, value) {
      this.day = value;
      this.shos = index;
      this.getSearch();
    },
    gohomes() {
      this.$router.go(-1);
    },
    qx() {
      this.isshow = !this.isshow;
      this.value = "";
      this.getSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
.xin-list {
  min-height: 100vh;
  padding-top: 50px;
  .item_list {
    width: 100%;
    background: #f7f7f7;
    padding-top: 0.1875rem;
    .list {
      height: 25px;
      margin: auto;
      background: #f7f7f7;
      color: #cccccc;
      font-size: 0.875rem;
      margin-bottom: 6px;
    }
    .fangda {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      padding: 0 3%;
      .fang {
        width: 100%;
        height: 6.25rem;
        background: #fefffe;
        border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
        margin: auto;
        margin-bottom: 10px;
        display: flex;
        .zi_list {
          width: 60%;
          height: 100%;

          p:first-child {
            width: 100%;
            height: 60%;
            color: #323332;
            font-size: 0.875rem;
            padding: 0.625rem;
            box-sizing: border-box;
            font-family: PingFang SC-粗体, PingFang SC;
            font-weight: normal;
          }
          .vottom {
            display: flex;
            justify-content: space-between;
            padding: 1.25rem 1.25rem;
            box-sizing: border-box;
          }
          .right-botttom {
            width: 100%;
            height: 40%;
            display: flex;
            align-items: center;
            padding: 0.625rem 0.625rem;
            .button {
              width: 4.25rem;
              height: 1.5rem;
              background: linear-gradient(180deg, #4ea3ff 0%, #007aff 100%);
              border-radius: 0.9375rem 0.9375rem 0.9375rem 0.9375rem;
              opacity: 1;
              color: #ffffff;
              font-size: 0.75rem;
              text-align: center;
              line-height: 1.5rem;
            }

            img {
              width: 0.75rem;
              height: 0.75rem;
            }
            p {
              color: #999999;
              font-size: 0.625rem;
            }
          }
        }
        .fang_img {
          width: 40%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .img-item {
            width: 90%;
            height: 90%;
            img {
              width: 100%;
              height: 100%;
              border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
            }
          }
        }
      }
    }
  }
  .box {
    width: 100%;
    // height: 46.5rem;
    background: #f7f7f7;
    padding: 8px 0;
    .banner {
      width: 100%;
      text-align: center;
      line-height: 43.6875rem;
      color: #cccccc;
      font-size: 0.875rem;
    }

    .tap {
      width: 100%;
      height: 2.8125rem;
      display: flex;
      align-items: center;
      justify-content: space-around;

      p {
        width: 5.1875rem;
        height: 2.5rem;
        background: #ffffff;
        border-radius: 1.1875rem 1.1875rem 1.1875rem 1.1875rem;
        opacity: 1;
        text-align: center;
        line-height: 2.5rem;
        color: #323332;
        font-size: 0.875rem;
      }
      .acp {
        text-align: center;
        line-height: 2.5rem;
        width: 5.25rem;
        height: 2.5rem;
        background: linear-gradient(180deg, #4ea3ff 0%, #007aff 100%);
        border-radius: 1.1875rem 1.1875rem 1.1875rem 1.1875rem;
        opacity: 1;
        color: #ffffff;
        font-size: 0.875rem;
      }
    }
  }
  .input {
    width: 100%;
    position: fixed;
    z-index: 11;
    top: 0;
    left: 0;
  }
  .list {
    width: 100%;
    height: 50px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    justify-content: space-around;
    padding: 5px 0;
    ::v-deep .van-dropdown-menu__item {
      background: #ffffff;
    }
    .van-search {
      width: 255px;
      height: 40px;
      background: #f5f5f5;
      border-radius: 467px 467px 467px 467px;

      ::v-deep .van-cell {
        background: #f7f7f7;
        border-radius: 467px 467px 467px 467px;
      }
    }
    p {
      color: #007aff;
      font-size: 0.875rem;
    }
    .two {
      display: flex;
      align-items: center;
      position: relative;

      img {
        position: absolute;
        width: 1.125rem;
        height: 1.125rem;
        left: 5rem;
      }
      input::input-placeholder {
        color: red !important;
      }
      input {
        color: black;
        font-size: 0.875rem;
        width: 14.6875rem;
        height: 2.125rem;
        background: #f7f7f7;
        border-radius: 29.1875rem 29.1875rem 29.1875rem 29.1875rem;
        opacity: 1;
        padding-left: 6.25rem;
        border: none;
      }
    }
    .one {
      .inp {
        width: 5.625rem;
        border: none;
        background: url("../../assets/bottom.png") no-repeat center right;
        background-size: 12px;
        text-align: center;
        font-size: 14px;
        color: #333;
      }
    }
  }
  .top {
    width: 100%;
    height: 3.125rem;
    display: flex;
    align-items: center;
    font-weight: bold;
    justify-content: space-around;
    .incon {
      margin-left: -2.5rem;
    }
  }
}
</style>